"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Links = void 0;
var _mui = require("@ori-ui/mui");
var _staticApiClientReact = require("@ori/static-api-client-react");
var _testidGenerator = _interopRequireDefault(require("@ori/testid-generator"));
var _react = require("react");
var _constants = require("./constants");
var _styles = require("./styles");
var _jsxRuntime = require("react/jsx-runtime");
const Links = ({
  items
}) => {
  const {
    getTestId
  } = (0, _testidGenerator.default)();
  const links = (0, _react.useMemo)(() => items.filter(item => item.linkType === _staticApiClientReact.StaticNavigationNavigationItemDtoLinkType.FooterColumnItem), [items]);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.Root, {
    "data-testid": getTestId(_constants.LINKS_LIST),
    children: links.map(item => /*#__PURE__*/(0, _jsxRuntime.jsx)(_mui.Typography, {
      "data-testid": getTestId(_constants.LINK),
      children: item.url ? /*#__PURE__*/(0, _jsxRuntime.jsx)("a", {
        "aria-label": item.title,
        href: item.url,
        title: item.title,
        children: item.title
      }) : item.title
    }, item.title))
  });
};
exports.Links = Links;